export default __webpack_public_path__ + "static/media/demo.9f10bc68.jpg";